import { Button, Image } from '@chakra-ui/react';

import { truefileServerApi } from 'api/truefilesServerApi';
import { IFileModel } from 'api/types/trueFileServerTypes';
import OpenIcon from 'assets/icons/open.svg';

export function OpenFileButton({ file }: { file: IFileModel }): JSX.Element {
  async function handleOpenFile(): Promise<void> {
    const sasResponse = await truefileServerApi.GET('/api/files/sas/read', {
      params: { query: { blobName: file.blobName } },
    });

    const sasUrl = `${sasResponse.data!.storageAccountUrl}${sasResponse.data!.containerName}/${sasResponse.data!.blobName}${sasResponse.data!.sasToken}`;
    window.open(sasUrl);
  }

  return (
    <Button
      onClick={handleOpenFile} p={0}
      variant='ghost' minW='unset'
      minH='unset'
    >
      <Image src={OpenIcon} boxSize='20px' />
    </Button>
  );
}
